import React, { useContext, useState } from "react";
import { Breadcrumb, Button } from "@boozallen-uip/uswds-react-core";
import { ACCESS_WAITING, BASE_TITLE, FOR_BUYERS_URL, HOME_URL } from "../../utlities/core.constants";
import { UserContext } from "../UserContext";
import AccessStatus from "../../components/AccessStatus.component";
import { SectionContainer } from "../shared.styled";
import PageHeader from "../../components/PageHeader/PageHeader.component";
import ProductTableContainer from "./ProductList/ProductTableContainer.component";
import RequestAcrModal from "./RequestAcrModal.component";
import "./ProductListContainerFC.css";

function ProductListContainerFC() {
  const { hasPendingRequestAccess, isAgencyUser } = useContext(UserContext);
  const [isRequestAcrOpen, setIsRequestAcrOpen] = useState(false);
  document.title = `${BASE_TITLE} - Product Listings`;
  return (
    <>
      {hasPendingRequestAccess ? <AccessStatus access={ACCESS_WAITING} /> : null}
      <PageHeader imageUrl="/page-banners/account_hero_2x.webp" backgroundSize='2800px 391px' className='2xl:!bg-cover'>
        Product Listings
      </PageHeader>
      <SectionContainer className="pt-0">
        <div className="mt-3 mb-4 flex flex-wrap items-center justify-between gap-3">
          <div>
            <Breadcrumb links={[{"href": HOME_URL, "text": "Home"}, {"href": FOR_BUYERS_URL, "text": "Product Listings"}]} />
            <h1 className="usa-sr-only">Product Listings</h1>
          </div>
          <div className="flex flex-wrap items-stretch gap-2 product-list-actions">
            {isAgencyUser ? (
              <Button type="button" outline onClick={() => setIsRequestAcrOpen(true)}>
                Request an ACR
              </Button>
            ) : null}
          </div>
        </div>
        <ProductTableContainer
          showVendorAction={false}
          onRequestAcr={isAgencyUser ? () => setIsRequestAcrOpen(true) : undefined}
        />
        {isAgencyUser ? (
          <RequestAcrModal isOpen={isRequestAcrOpen} onClose={() => setIsRequestAcrOpen(false)} />
        ) : null}
      </SectionContainer>
    </>
  );
}

export default ProductListContainerFC;
